import Home from '/public/pages/home.svelte';
import Login from '/public/pages/login.svelte';
import ForgotPassword from '/public/pages/forgot-password.svelte';
import ResetPassword from '/public/pages/reset-password.svelte';
import Logout from '/public/pages/logout.svelte';
import ActivateAccount from '/public/pages/activate-account.svelte';
import TwoFASetup from '/public/pages/two-fa-setup.svelte';
import TwoFAChallenge from '/public/pages/two-fa-challenge.svelte';
import OneLeague from '/public/pages/games/OneLeague.svelte';
import MultiLeague from '/public/pages/games/MultiLeague.svelte';


const routes = {
    '/': Home,

    '/l/:leagueID': OneLeague,
    
    '/m/:leagueID': MultiLeague,

    '/login': Login,    

    '/forgot-my-password': ForgotPassword,

    '/password-reset/:hash': ResetPassword,

    '/logout': Logout,

    '/activate-account/:hash': ActivateAccount,

    '/two-fa-setup/:hash': TwoFASetup,

    '/two-fa-challenge/:hash': TwoFAChallenge
}

export { routes }
